import { Group, Paper, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';

import { PublicationCardIdentifiers } from '@/module/Author/Publication/components/PublicationCardIdentifiers';
import { PublicationTitle } from '@/module/Author/Publication/components/PublicationTitle';

import { BdiList, JournalVolume, LanguagePill, NoOfAuthors, PublishedAtText, WosIndexAt } from '@feature/utils';

import { Abstract } from './../../model/AbstractTypes';
import classes from './AbstractCard.module.css';

export interface AbstractCardProps {
  abstract: Abstract;
  to?: string;
  onClick?: () => void;
}

export function AbstractCard({ abstract, to, onClick }: AbstractCardProps) {
  const {
    publishedAt,
    authors,
    language,
    noOfPages,
    conference,
    volumeIsbn,
    volumeNo,
    volume,
    journal,
    startPage,
    endPage,
    identifiers,
    journalType,
    bdis,
    wosIndexingYear,
  } = abstract;

  return (
    <Paper
      className={classes.card}
      component={to ? Link : undefined}
      onClick={onClick}
      to={to}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="xs">
        <PublicationTitle publication={abstract} />
        <Group>
          {journal && (
            <>
              <Text>
                {journal.title} {journalType?.name ? `(${journalType?.name})` : ''}
              </Text>
              <JournalVolume
                volume={volume}
                volumeNo={volumeNo}
                noOfPages={noOfPages}
                endPage={endPage}
                startPage={startPage}
              />
            </>
          )}
        </Group>
        <BdiList bdis={bdis} />
        {volumeIsbn && <Text>ISBN Volum: {volumeIsbn}</Text>}
        {conference && <Text>{conference.conferenceName}</Text>}
        <Group>
          <PublishedAtText
            date={publishedAt}
            size="sm"
            c="dimmed"
          />
          <WosIndexAt year={wosIndexingYear} />
          <NoOfAuthors authors={authors} />
        </Group>
        <Group>
          <LanguagePill language={language} />
          {identifiers && <PublicationCardIdentifiers identifiers={identifiers} />}
        </Group>
      </Stack>
    </Paper>
  );
}
